// Libraries
import React from 'react';

// Styled
import {Card, CardContent} from 'Components/flowChart/components/NodePreview/components/styled';

// Types
import {INodePreviewProps} from 'Components/flowChart/components/NodePreview/types';

// Constants
import {NODE_PREVIEW_COMPONENT} from 'Components/flowChart/components/NodePreview/constants';

const PATH = 'components/components/flowChart/components/NodePreview/index.tsx';

const NodePreview: React.FC<INodePreviewProps<any>> = (props) => {
	try {
		const Component = NODE_PREVIEW_COMPONENT[props.node.type];

		if (!Component) {
			return null;
		}

		return (
			<Card>
				<CardContent>
					<Component {...props} />
				</CardContent>
			</Card>
		);
	} catch (error) {
		props.onError?.(error, {
			component: PATH,
			action: 'render -> NodePreview',
			args: {props}
		});

		return null;
	}
};

NodePreview.defaultProps = {
	timezone: 'Asia/Ho_Chi_Minh'
};

export default NodePreview;
